// extracted by mini-css-extract-plugin
export default {"BoxRedes":"redes_BoxRedes__4lFN4","BoxRed":"redes_BoxRed__iuxhk","BoxSigue":"redes_BoxSigue__BJhNK","ImgRed":"redes_ImgRed__2zLtK"};